import "./App.css";
import React, { useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import {
  CircularProgress,
  Backdrop,
  Typography,
  Box,
  useMediaQuery,
} from "@mui/material";
import MainContainer from "./components/MainContainer";
import Layout from "./components/Layout";
import ProductGrid from "./components/ProductGrid";
import ProductDetail from "./components/ProductDetail";
import AppNavbar from "./components/AppNavbar";
import Footer from "./components/Footer";
import { useTheme } from "@mui/material/styles";
import BottomNavigator from "./components/BottomNavigator";
import AddToCart from "./components/AddToCart";
import ScrollToTop from "./components/ScrollToTop";
import TitleManager from "./components/TitleManager";

// lazy loading component
const About = React.lazy(() => import("./components/About"));
const Contact = React.lazy(() => import("./components/Contact"));
const FAQ = React.lazy(()=> import('./components/FrequentlyQuestions'))

const loading = (
  <Backdrop
    sx={(theme) => ({ color: "#000", zIndex: theme.zIndex.drawer + 1 })}
    open={true}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <CircularProgress color="inherit" />
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Loading
      </Typography>
    </Box>
  </Backdrop>
);

function App() {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const [navValue, setNavValue] = useState(0);

  return (
    // <AuthProvider>
    <>
      <HashRouter>
        <React.Suspense fallback={loading}>
          <TitleManager />
          <ScrollToTop />
          <AppNavbar />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<MainContainer />} />
              <Route
                path="product_list/:category_id"
                name="Product List"
                element={<ProductGrid />}
              />
              <Route
                path="/product_details/:id"
                name="Product Details"
                element={<ProductDetail />}
              />
              <Route
                path="/add_to_cart/"
                name="Add to Cart"
                element={<AddToCart />}
              />
              <Route path="contact" name="contact" element={<Contact />} />
              <Route path="about" name="about" element={<About />} />
              <Route path="faq" name="faq" element={<FAQ />} />
            </Route>
          </Routes>
          <Footer />
          {isMobileView && (
            <BottomNavigator navValue={navValue} setNavValue={setNavValue} />
          )}
        </React.Suspense>
      </HashRouter>
    </>
    // </AuthProvider>
  );
}

export default App;
